module.exports = __webpack_public_path__ + "img/question_top_bg_.fc39abd7.png";